export enum WitchQueenDungeonHashes {
  Duality = 2823159265,
  SpireOfTheWatcher = 1262462921,
}

export enum LightfallDungeonHashes {
  GhostsOfTheDeep = 313828469,
  WarlordsRuin = 2004855007,
}

export enum FinalShapeDungeonHashes {
  VespersHost = 300092127,
  SunderedDoctrine = 3834447244,
}
